exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dark-bg{\n\tbackground-color: #323643;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/baba_frontend/src/app/auth/sign-in/sign-in.component.css
// module id = ../../../../../src/app/auth/sign-in/sign-in.component.css
// module chunks = main